import React, { useEffect, useState, useCallback } from 'react';
import { object, number } from 'prop-types';
import classnames from 'classnames';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import CustomOrder from '@fiverr-private/custom_order/src/entries/CustomOrderEntry';
import { buildCustomOrderProps } from './api';

import './style.scss';

const CustomOrderTab = ({ responseTime }, { requestContext, pathfinderWrapper, logger, currencyConverter }) => {
    const [data, setData] = useState(null);
    const [isFetchFailed, setIsFetchFailed] = useState(false);

    useEffect(() => {
        if (!data) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const fetchData = useCallback(() => {
        const { params } = requestContext;
        const { slug: gigSlug, username: sellerUsername } = params;

        buildCustomOrderProps({ sellerUsername, gigSlug, pathfinderWrapper, logger })
            .then(setData)
            .catch(() => setIsFetchFailed(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [requestContext]);

    const retryFetchData = () => {
        setIsFetchFailed(false);
        fetchData();
    };

    const currency = currencyConverter.getCurrency();
    const classNames = classnames('custom-order-tab', { 'is-loading': !data && !isFetchFailed });

    return (
        <div className={classNames}>
            {data &&
            <CustomOrder {...data}
                currency={currency}
                responseTime={responseTime}
                ctaText={<I18n k={'gig_page_perseus.custom_order.send_message'}/>}
                isFourthPackageTest/>
            }
            {isFetchFailed &&
            <div className="submit-retry">
                <I18n k={'gig_page_perseus.custom_order.something_wrong'}/>
                <button onClick={retryFetchData}>
                    <I18n k={'gig_page_perseus.custom_order.try_again'}/>
                </button>
            </div>
            }
        </div>
    );
};

CustomOrderTab.propTypes = {
    responseTime: number
};

CustomOrderTab.contextTypes = {
    requestContext: object,
    currencyConverter: object,
    pathfinderWrapper: object,
    logger: object
};

export default CustomOrderTab;
